import { Component } from '@angular/core';

@Component({
  selector: 'app-te-role-auth',
  templateUrl: './te-role-auth.component.html',
  styleUrls: ['./te-role-auth.component.css']
})
export class TeRoleAuthComponent {

}
